import React from "react";
import { useParams } from "react-router-dom";

import SettingsLayout from "components/Screens/Setting/SettingsLayout/SettingsLayout";
import CountryDetails from "components/Screens/Setting/CountryDetails/CountryDetails";

import { TIME_OFF_ROUTES } from "constants/routes";
import { COUNTRIES } from "components/Screens/Setting/constants";

function CountryDetailsWrapper() {
  const { countryName } = useParams();

  const formatTitle = () => {
    if (countryName && COUNTRIES[countryName]) {
      return `${COUNTRIES[countryName]}`;
    }
    return "Time Off";
  };

  return (
    <SettingsLayout title={formatTitle()} linkName="Time Off" link={TIME_OFF_ROUTES.BASE}>
      <CountryDetails />
    </SettingsLayout>
  );
}

export default CountryDetailsWrapper;
